import React, { useState, useRef, useEffect } from "react";
import "./ContactsKanban.css";
import { useSelector } from "react-redux";
import { useSession } from "../../../authentications/SessionContext";
import Dropdown from "../../Kanban/Dropdown/Dropdown";
import Modal from "../../Kanban/Modal/Modal";
import SchuduleScreen from "../../Kanban/Card/SchuduleScreen";
import ContactsImg from "../../../Images/contacts.png";
import { FaSearch, FaStar, FaCalendarAlt } from "react-icons/fa";
import { PAGINATION_DEFAULT_LIMIT } from "../../../utilities/constants";
import ScheduleActivitiesList from "../../Kanban/Card/ScheduleActivitiesList";
import { activityFormat } from "../../../DataApi/activity_format";
import { handleResponse } from "../../../utilities/handleResponse";
import useConfirmationModal from "../../ConfirmationModal/useConfirmationModal";
import ActionButton from "../../Buttons/ActionButton";
import { unLink } from "../../../DataApi/unlink";
import { MoreHorizontal } from "react-feather";
import Pagination from "../../Table/TableFooter/Pagination";
import { useLanguage } from "../../LangTranslation/LanguageContext";

const ContactsKanban = ({
  searchWithType,
  handleChangeSearch,
  handleSubmitSearch,
  handleCreateClick,
  setSelectedRecord,
  selectedRecord,
  refetchData,
}) => {
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;
  const { contactsList, length } = useSelector((state) => state.contacts);
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const dropdownRef = useRef(null);
  const [itemsPerPage] = useState(PAGINATION_DEFAULT_LIMIT);
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [buttonType, setButtonType] = useState("button");

  const {
    setIsDisabled: setDisableModalButton,
    ConfirmationModal,
    setTitle,
    setMetaData,
    toggleModal,
    setOpenModal: setOpenConfirmationModal,
  } = useConfirmationModal();

  const inputRef = useRef(null);

  const handleShowDropdown = (event, index) => {
    event.stopPropagation();
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  const handleClickSearchBar = (e) => {
    if (!isSearchBarOpen) {
      e.preventDefault();
      setIsSearchBarOpen(true);
      inputRef.current.focus();
      setButtonType("submit");
    }
  };
  const handleChangePage = (value) => {
    setCurrentPage(value);
  };
  const handleBlur = (event) => {
    if (!event.relatedTarget || event.relatedTarget.type !== "submit") {
      setIsSearchBarOpen(false);
    }
  };
  const handleDeleteContact = (record) => {
    setOpenConfirmationModal(true);
    setTitle("");
    setMetaData({
      dangerouslySetInnerHTML: "",
      primaryButton: "Yes",
      secondaryButton: "No",
    });
    setSelectedRecord(record);
    setOpenDropdownIndex(null);
  };

  const handleConfirmDelete = async () => {
    setDisableModalButton(true);

    unLink({
      id: selectedRecord.id,
      company_id,
      context,
      model: "res.partner",
    }).then((response) => {
      response = JSON.parse(response);
      if (response.result) {
        setSelectedRecord([]);
        refetchData();
        setOpenConfirmationModal(false);
      }
      handleResponse({
        response,
        setMetaData,
        setTitle,
        successMessage: "Contact Deleted Successfully",
      });
      setDisableModalButton(false);
      setOpenDropdownIndex(null);
    });
  };

  useEffect(() => {
    const offset = (currentPage - 1) * itemsPerPage;
    refetchData({ offset });
  }, [currentPage]);

  return (
    <>
      <ConfirmationModal
        handleYes={handleConfirmDelete}
        handleNo={() => setOpenConfirmationModal(false)}
      />

      {showScheduleModal && (
        <Modal
          isOpen={showScheduleModal}
          onClose={() => setShowScheduleModal(false)}
        >
          <SchuduleScreen
            handleCloseModal={() => setShowScheduleModal(false)}
          />
        </Modal>
      )}

      <div className="contacts_kanban_Container">
        <div className="contacts_kanban_inner_Container">
          <div className="d-flex justify-content-between">
            <div className="friends_text_div">{t["Friends List"]}</div>
            <div className="d-flex g-4">
              <div></div>
              <form
                onSubmit={(e) => {
                  if (isSearchBarOpen) {
                    handleSubmitSearch(e);
                  } else {
                    e.preventDefault();
                  }
                }}
              >
                <div
                  className={`search-bar ${isSearchBarOpen ? "open" : ""}`}
                  onClick={handleClickSearchBar}
                >
                  <input
                    ref={inputRef}
                    className="search-input"
                    placeholder={t["Search here"]}
                    value={searchWithType}
                    onChange={handleChangeSearch}
                    type="search"
                    onBlur={handleBlur}
                  />
                  <button className="search-submit">
                    <i className="search_icon">
                      <FaSearch />
                    </i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="d-flex justify-content-evenly">
            <hr style={{ width: "100%" }} />
          </div>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 g-4">
            {contactsList?.map((record, index) => (
              <div
                className="col d-flex justify-content-evenly"
                key={record.id}
              >
                <div
                  className="card p-0 contacts_card"
                  style={{ width: "410px", height: "auto" }}
                >
                  <div className="card-content-container d-flex">
                    <div className="image-container" style={{ width: "20%" }}>
                      <img
                        src={ContactsImg}
                        width="40px"
                        height="40px"
                        className="card_img"
                        alt="user"
                      />
                    </div>
                    <div className="details-container" style={{ width: "80%" }}>
                      <div className="d-flex justify-content-between">
                        <div className="display_name">
                          {record.display_name}
                        </div>
                        <div className="header_title_more">
                          <MoreHorizontal
                            onClick={(event) =>
                              handleShowDropdown(event, index)
                            }
                            ref={dropdownRef}
                          />
                          {openDropdownIndex === index && (
                            <Dropdown
                              className="board_Dropdown"
                              onClose={() => setOpenDropdownIndex(null)}
                            >
                              <div className="d-flex flex-column gap-2">
                                <ActionButton
                                  name="Edit Contact"
                                  onClick={() => {
                                    handleCreateClick();
                                    setSelectedRecord(record);
                                    setOpenDropdownIndex(null);
                                  }}
                                />
                                <ActionButton
                                  name="Delete Contact"
                                  onClick={() => handleDeleteContact(record)}
                                />
                              </div>
                            </Dropdown>
                          )}
                        </div>
                      </div>
                      <div className="email">{record.email}</div>
                      <div className="d-flex">
                        <div className="ms-2">
                          <FaStar style={{ color: "gold" }} />
                          {record.opportunity_count}
                        </div>
                        <div className="ms-2">
                          <FaCalendarAlt /> {record.meeting_count}
                        </div>
                        <div className="ms-2">${record.opportunity_count}</div>
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      handleCreateClick();
                      setSelectedRecord(record);
                    }}
                    className="view_button"
                  >
                   {t["View"]}
                  </button>
                </div>
              </div>
            ))}
          </div>
          <Pagination
            ListViewData={contactsList}
            indexOfFirstItem={currentPage * itemsPerPage - itemsPerPage}
            indexOfLastItem={currentPage * itemsPerPage}
            currentPage={currentPage}
            handleChangePage={handleChangePage}
            PAGINATION_DEFAULT_LIMIT={itemsPerPage}
            totalDataLength={length}
          />
        </div>
      </div>
    </>
  );
};

export default ContactsKanban;
